import { render, staticRenderFns } from "./ass-rules.vue?vue&type=template&id=5080a98a"
import script from "./ass-rules.vue?vue&type=script&lang=js"
export * from "./ass-rules.vue?vue&type=script&lang=js"
import style0 from "./ass-rules.vue?vue&type=style&index=0&id=5080a98a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports